import { HomepageSearchBarType } from 'types'
import { RolodexEntryJson } from 'types/rolodex/rolodexEntries'
import { parseBoolean, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

/**
 * An entry that represents a homepage config
 */
export class GeckoHomepageConfig extends GeckoEntryBase<
  {
    search_bar_type: HomepageSearchBarType
    landing_page_redirect: string
    show_jump_cards: boolean
    show_recent_activity: boolean
  },
  {
    organization: string
    site: string | undefined
  }
> {
  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        search_bar_type:
          (parseString(json.data.search_bar_type) as HomepageSearchBarType) ??
          HomepageSearchBarType.Default,
        landing_page_redirect:
          parseString(json.data.landing_page_redirect) ?? '',
        show_jump_cards: parseBoolean(json.data.show_jump_cards) ?? true,
        show_recent_activity:
          parseBoolean(json.data.show_recent_activity) ?? true,
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? undefined,
      },
      {}
    )
  }

  /**
   * A simple factory method which creates a homepage config from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoHomepageConfig(json)
  }
}
